<template>
	<div class="w-full flex flex-col items-center gap-4 px-4">
		<div class="w-full flex items-center gap-3">
			<SearchInput
				class="w-full h-full"
				placeholder="PESQUISAR POR NOME, CPF OU TELEFONE"
				:search="search"
				@input="search = $event"
			/>
			<button
				class="w-auto btn btn-primary btn-block px-5"
				@click="NewIndicator()"
			>
				CADASTRAR
			</button>
		</div>
		<div class="w-full px-0">
			<NewDatatable
				v-model="filteredIndicators"
				:headers="headers"
			>
				<template #row="{ item }">
					<div class="datatable-cell">
						<b>{{ item.name.toUpperCase() }}</b>
					</div>
					<div class="datatable-cell">
						{{ item.cpf || '-' }}
					</div>
					<div class="datatable-cell">
						{{ item.professional_advice_description || '-' }}
					</div>
					<div class="datatable-cell">
						{{ item.number || '-' }}
					</div>
					<div class="datatable-cell">
						{{ item.uf_professional_advice || '-' }}
					</div>
					<div class="datatable-cell">
						{{ item.rqe || '-' }}
					</div>
					<div class="datatable-cell">
						{{ item.uf_rqe || '-' }}
					</div>
					<div class="datatable-cell">
						{{ item.phone || '-' }}
					</div>
					<div class="datatable-cell flex justify-end gap-3">
						<template v-if="!item.stamp_id">
							<button
								type="button"
								class="btn btn-light-warning btn-sm mr-3"
								@click.stop="EditIndicator(item)"
							>
								<i class="fa fa-pencil"></i>
							</button>
							<button
								type="button"
								class="btn btn-light-danger btn-sm"
								@click.stop="DeleteButton(item)"
							>
								<i class="fa fa-trash"></i>
							</button>
						</template>
					</div>
				</template>
			</NewDatatable>
		</div>

		<div
			class="modal fade"
			id="indicator_modal"
		>
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-body p-4">
						<div
							class="form-row align-items-center mb-3 d-flex justify-content-end"
						>
							<div class="col-md-auto px-0">
								<button
									type="button"
									class="btn btn-light p-3"
									data-dismiss="modal"
								>
									<i class="far fa-times mx-1"></i>
								</button>
							</div>
						</div>
						<IndicatorForm
							ref="indicator"
							:base_name="search"
							:indicator_base="indicator"
							:organization_id="organization_id"
							@saved="IndicatorSaved"
							@deleted="IndicatorDeleted"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import DataTables from '../../shared/DataTables'
	import Swal from 'sweetalert2'
	import { mapGetters } from 'vuex'
	import IndicatorForm from '../../shared/IndicatorForm.vue'
	import Helpers from '../../../helpers'

	const _ = require('lodash')
	const helpers = new Helpers()

	export default {
		name: 'Indicator',
		components: {
			DataTables,
			IndicatorForm,
		},
		props: {
			organization_id: {
				type: [String, Number],
				required: true,
				default: null,
			},
		},
		data() {
			return {
				search: '',
				indicators: [],
				indicator: null,
				headers: [
					{ value: 'name', text: 'NOME' },
					{ value: 'cpf', text: 'CPF', width: '8.8rem' },
					{
						value: 'professional_advice_description',
						text: 'CONSELHO PROFISSIONAL',
						width: '15%',
					},
					{ value: 'number', text: 'NÚMERO' },
					{
						value: 'uf_professional_advice',
						text: 'UF',
						width: '4rem',
					},
					{ value: 'rqe', text: 'RQE' },
					{ value: 'uf_rqe', text: 'UF', width: '4rem' },
					{ value: 'phone', text: 'TELEFONE', width: '9rem' },
					{ value: 'actions', text: '', width: '8.8rem' },
				],
			}
		},
		computed: {
			...mapGetters('auth', ['stamps']),
			filteredIndicators() {
				if (!this.search) return this.indicators

				const search = helpers.RemoveAcento(this.search).toLowerCase()
				return this.indicators.filter(indicator => {
					let allowed = false

					if (
						indicator.name &&
						helpers
							.RemoveAcento(indicator.name)
							.toLowerCase()
							.includes(search)
					) {
						allowed = true
					}

					if (
						!allowed &&
						indicator.cpf &&
						helpers
							.RemoveAcento(
								helpers.SanitizedDocument(indicator.cpf)
							)
							.toLowerCase()
							.includes(helpers.SanitizedDocument(search))
					) {
						allowed = true
					}

					if (!allowed && indicator.phone) {
						let phone

						try {
							phone = JSON.parse(
								indicator.phone.replace(/\\/g, '')
							)
						} catch (err) {
							phone = []
						}

						if (Array.isArray(phone) && phone.length > 0) {
							phone.forEach(tel => {
								if (
									tel &&
									tel.replace(/\D/g, '').indexOf(search) > -1
								) {
									allowed = true

									return
								}
							})
						}
					}

					return allowed
				})
			},
		},
		methods: {
			OpenModal() {
				window.jQuery('#indicator_modal').modal('show')
			},
			CloseModal() {
				window.jQuery('#indicator_modal').modal('hide')
			},
			async GetIndicators() {
				window.api
					.call('post', '/get-indicators', {
						organization_id: this.organization_id,
					})
					.then(({ data }) => {
						if (data.response) {
							this.indicators = _.sortBy(data.indicators, 'name')
						}
					})
			},
			NewIndicator() {
				this.$refs.indicator.ClearForm(true)
				this.OpenModal()
			},
			EditIndicator(indicator) {
				if (indicator.stamp_id) return

				this.indicator = indicator
				this.OpenModal()
			},
			IndicatorSaved() {
				this.GetIndicators()

				this.search = ''

				this.CloseModal()
			},
			IndicatorDeleted() {
				this.GetIndicators()

				this.CloseModal()
			},
			DeleteButton(indicator) {
				Swal.fire({
					title: 'Tem certeza?',
					text: 'Esta ação não pode ser desfeita!',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Sim, deletar',
					cancelButtonText: 'Cancelar',
				}).then(result => {
					if (result.isConfirmed) {
						this.$refs.indicator.Delete(indicator)
					}
				})
			},
		},
		beforeMount() {
			this.GetIndicators()
		},
	}
</script>

<style lang="css" scoped>
	.modal-dialog {
		width: 90% !important;
		max-width: 90% !important;
	}

	.action-buttons {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		gap: 1rem;
		flex-wrap: nowrap;
		width: 100%;
	}
</style>
